import { generateRequestPayload } from "./hash";

/**
 * Adds security headers to the request configuration
 * Uses the exact same logic as the working version
 */
const addSecurityHeaders = ({ config, secretKey, isNormalizePath }) => {
  const path = config.url || "";
  const method = (config.method || "GET").toUpperCase();
  const body = config.data || {};
  const params = config.params || {};
  const timestamp = new Date().getTime();

  const { controlHash, payload } = generateRequestPayload(
    path, // Pass path exactly as original
    method,
    body,
    params,
    timestamp,
    secretKey
  );

  const headers = {
    ...config.headers,
    "x-client-request-control": controlHash,
    "x-client-timestamp": timestamp.toString(),
  };

  // Only add payload in development environment
  if (process.env.NODE_ENV === 'development') {
    headers["x-client-payload"] = payload;
  }

  return {
    ...config,
    headers,
  };
};

/**
 * Creates a security interceptor for axios
 */
const createSecurityInterceptor = (secretKey, isNormalizePath = false) => {
  return (config) => {
    return addSecurityHeaders({
      config,
      secretKey,
      isNormalizePath,
    });
  };
};

export { addSecurityHeaders, createSecurityInterceptor };